import { createFileRoute, Link } from "@tanstack/react-router"
import { Button } from "toptaal-shared"

export const Route = createFileRoute("/test-support/")({
  component: TestSupportPage,
})

function TestSupportPage() {
  return (
    <main className="mx-auto w-full max-w-5xl py-10">
      <h1 className="font-domine text-3xl font-bold text-primary-dark-blue">
        Test support
      </h1>
      <p className="mt-2 mb-8 text-primary-dark-blue">
        Hulpmiddelen om testscenario&apos;s in Mijn TopTaal klaar te zetten.
      </p>

      <section className="rounded-lg border border-primary-accent-blue bg-white p-6">
        <h2 className="font-domine text-xl font-bold text-primary-dark-blue">
          Rapportages
        </h2>
        <p className="mt-2 mb-5 text-primary-dark-blue">
          Maak voor een bestaande cursist handmatig een rapportage todo aan.
        </p>
        <Button variant="primary" asChild>
          <Link to="/test-support/rapportage-todo-aanmaken">
            Maak rapportage todo handmatig aan
          </Link>
        </Button>
      </section>
    </main>
  )
}
